import React from 'react';
import './ContactSection.css';
import { useTranslation } from 'react-i18next';
import { FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';
import SectionHeader from '../sectionHeader/SectionHeader';
import SectionWrap from '../SectionWrap/SectionWrap';

function ContactSection() {
  const { t } = useTranslation();

  // بيانات الاتصال الرسمية لشركة المحاماة
  const phoneNumber = "00963-930-644-449"; 
  const emailAddress = "info@albarede.com"; 

  return (
    <div className='containerNew' data-aos='fade-up'>
        <SectionWrap>
        <SectionHeader title={t('ContactUs')} disc={t('ContactUs_disc')} />
    <section className="contact-global-wrapper">
      <div className="contact-grid-container">
        
        {/* الكتل اليمنى: كروت معلومات التواصل الفاخرة */}
        <div className="contact-info-side">
          
          {/* كرت الهاتف التفاعلي */}
          <div className="premium-contact-card" data-aos='fade-up'>
            <div className="card-icon-wrap">
              <FiPhone />
            </div>
            <div className="card-details-wrap">
              <span>{t('Phone_Number')}</span>
              <p dir="rtl">{phoneNumber}</p>
              <a href={`tel:+963930644449`} className="smart-action-btn phone-action">
                {t('Get_Touch')}
              </a>
            </div>
          </div>

          {/* كرت البريد الإلكتروني التفاعلي */}
          <div className="premium-contact-card" data-aos='fade-up'>
            <div className="card-icon-wrap">
              <FiMail />
            </div>
            <div className="card-details-wrap">
              <span>{t('Email_Address')}</span>
              <p>{emailAddress}</p>
              <a href={`mailto:${emailAddress}`} className="smart-action-btn email-action">
                {t('sendEmailNow')}
              </a>
            </div>
          </div>

          {/* كرت العنوان وساعات العمل */}
          <div className="premium-contact-card layout-two-rows" data-aos='fade-up'>
            <div className="sub-info-item">
              <div className="card-icon-wrap mini"><FiMapPin /></div>
              <div className="card-details-wrap">
                <span>{t('contactUsTitle3')}</span>
                <p>{t('contactUsInfo3')}</p>
              </div>
            </div>
            <div className="sub-info-item">
              <div className="card-icon-wrap mini"><FiClock /></div>
              <div className="card-details-wrap">
                <span>{t('hoursTitle')}</span>
                <p>{t('hoursDesc')}</p>
              </div>
            </div>
          </div>

        </div>

        {/* الكتلة اليسرى: مربع الخريطة المدمج برابط التضمين الدقيق الخاص بك */}
        <div className="contact-map-side" data-aos='fade-up'>
          <div className="premium-map-card">
            {/* تم وضع رابط الـ src الدقيق الخاص بك هنا لضمان إسقاط الدبوس بدقة متناهية */}
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3327.1098550395764!2d36.248944359846455!3d33.49851887348127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1518de3989521377%3A0x3bf73545886bf6bd!2z2YHZhtiv2YIg2YPZiNmK2YYg2LPZhtiq2LE!5e0!3m2!1sar!2s!4v1780984458906!5m2!1sar!2s" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="شركة البريدي للمحاماة - كوين سنتر"
            ></iframe>
            {/* القناع الزجاجي والظلال الفخمة المحيطة بالخريطة */}
            <div className="map-luxury-overlay"></div>
          </div>
        </div>

      </div>
    </section>
    </SectionWrap>
    </div>
  );
}

export default ContactSection;